export const DateDDMMYYYY=(TimeStamp)=>{
    var myDate = new Date(TimeStamp);
    var date = (myDate.getDate()<10?'0':'')+(myDate.getDate());
    var month = (myDate.getMonth()+1<10?'0':'')+(myDate.getMonth()+1);
    var year = myDate.getFullYear() +543;
    return date+"/"+month+"/"+year;
}

export const startdateDDMMYYYY=()=>{
    var myDate = new Date();
    var date = "01"
    var month = (myDate.getMonth()+1<10?'0':'')+(myDate.getMonth()+1);
    var year = myDate.getFullYear() +543;
    return date+"/"+month+"/"+year;
}
export const DateYYYYMMDD=(date)=>{
    var dateSp = date.split("/");
    var dataRe = dateSp[2]-543 +"-"+dateSp[1]+"-"+dateSp[0];
    return dataRe
}

